import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import MarkAsSeenButtonView from './MarkAsSeenButtonView.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { useListActions } from '@/helpers/composables/useListActions';
import { toastError } from '@/helpers/toast/toast-helper';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { ObjectType } from '@/@types/graphql-types';
import { SeenListEvents } from '@/enums/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkAsSeenButtonGraphql',
  props: {
    titleId: null,
    titleObjectId: null,
    titleObjectType: null,
    titleName: { default: '' },
    seasonNumber: null,
    episodeNumber: null,
    showSeenProgress: null,
    isTitleSeen: { type: Boolean },
    lightBackground: { type: Boolean },
    saving: { type: Boolean },
    useCustomEvent: { type: Boolean },
    trackingAction: { default: 'watchlist' },
    showDetails: null
  },
  emits: ['markAsSeen'],
  setup(__props: any, { emit }) {

const props = __props as { titleId: string, titleObjectId: number, titleObjectType: ObjectType, titleName: string, seasonNumber?: number | null, episodeNumber?: number | null, showSeenProgress?: number | null, isTitleSeen?: boolean, lightBackground?: boolean, saving?: boolean, useCustomEvent?: boolean, trackingAction: string, showDetails?: {
			objectId: number;
			objectType: ObjectType;
		} | null };

const TOAST_DURATION = 3000;





const { tc } = useI18n();
const { setInSeenlist } = useListActions();

const localSaving = ref(false);

const savingStatus = computed(() => localSaving.value || props.saving);

function trackEvent(category: string) {
	const action = props.trackingAction;
	let value;

	if (props.titleObjectType === ObjectType.Show && props.showSeenProgress) {
		value = props.showSeenProgress < 100 ? 1 : 0;
	}

	const properties = { action, value };

	const contexts = [
		new SnowplowTitleContextGraphql(
			props.showDetails?.objectId ?? props.titleObjectId,
			props.showDetails?.objectType ?? props.titleObjectType,
			props.seasonNumber,
			props.episodeNumber
		),
	];

	TrackingHelper.trackEvent(category, properties, contexts);
}

async function handleMarkAsSeen() {
	if (!props.useCustomEvent) {
		if (savingStatus.value) return;

		localSaving.value = true;

		try {
			const category = props.isTitleSeen ? SeenListEvents.REMOVE : SeenListEvents.ADD;

			const episodeFields =
				props.seasonNumber && props.episodeNumber
					? {
							seasonNumber: props.seasonNumber,
							episodeNumber: props.episodeNumber,
					  }
					: {};

			trackEvent(category);

			await setInSeenlist(props.titleId, !!props.isTitleSeen, {
				objectType: props.titleObjectType,
				objectId: props.titleObjectId,
				title: props.titleName,
				...episodeFields,
			});
		} catch (e) {
			console.error('<MarkAsSeenButton> handleMarkAsSeen', e);
			toastError({ message: tc('WEBAPP_SEENLIST_TOAST_ERROR'), duration: TOAST_DURATION });
		} finally {
			localSaving.value = false;
		}
	} else {
		emit('markAsSeen');
	}
}

return { __sfc: true,TOAST_DURATION, props, emit, tc, setInSeenlist, localSaving, savingStatus, trackEvent, handleMarkAsSeen, MarkAsSeenButtonView }
}

})